export const SIMPLIROUNDS_EVENT_TYPES = [
	'rounding-completed',
	'rounding-overdue',
	'patient-survey-completed',
	'rounding-schedule-changed',
] as const;

export const PATIENT_EVENT_LOG_TYPES = [...SIMPLIROUNDS_EVENT_TYPES] as const;

export type PatientEventLogType = typeof PATIENT_EVENT_LOG_TYPES[number];

export class PatientEventLogEntry {
	eventId: string;

	type: PatientEventLogType;

	timestamp: string;

	facilityId: string;

	patientId: string;

	createdAt: string;

	completedBy: string;

	completedByName: string;

	surveyId?: string;

	oldValues?: Array<string | number | boolean | null>;

	newValues?: Array<string | number | boolean | null>;

	constructor(partial: Partial<PatientEventLogEntry>) {
		if (!partial) return;

		Object.assign(this, partial);

		['timestamp', 'createdAt'].forEach((key) => {
			if (partial[key]?.toDate) {
				this[key] = partial[key].toDate();
			}
		});
	}
}
